import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ReviewDetail } from "../../model/v2/review/review-detail";
import { ReviewSummary } from "../../model/v2/review/review-summary";
import { BaseService } from "../shared/base.service";

@Injectable({
    providedIn: 'root'
})

export class ReviewService {
    constructor(private baseService: BaseService) { }

    getReviewSummary(npi: string): Observable<ReviewSummary> {
        return this.baseService.get<ReviewSummary>(`Review/GetReviewsSummary/npi/${npi}`);
    }

    getReviewDetail(npi: string): Observable<ReviewDetail> {
        return this.baseService.get<ReviewDetail>(`Review/GetReviewsDetails/npi/${npi}`);
    }
}
